export default function Example() {
    return (
        <div className="home-content">
            <h1>Example Interpreation</h1>
            <p><b>Coming soon!</b></p>
        </div>
    )
}